import React from "react";
import { useOutletContext } from 'react-router-dom';
import HelmetSEO from '../../componentesEspeciales/helmetSEO';

function Privacidad(){
    const { usuario, cargandoUsuario } = useOutletContext() || {};

    return(
        <>
          <HelmetSEO
            titulo="Política de privacidad | Zervicy"
            descripcion="Consulta cómo Zervicy recopila, utiliza y protege la información personal de usuarios, compradores y vendedores."
          />
        <div>

          <div className="container py-4">
            <div className="row justify-content-center">
              <div className="col-12 col-lg-10">

                <div className="mb-4">
                  <h1 className="h3 fw-bold mb-1">Política de privacidad</h1>
                  <p className="text-muted mb-0">
                    Aquí encontrarás información sobre cómo recopilamos, utilizamos y protegemos la información personal dentro de Zervicy.
                  </p>
                </div>

                <div className="card border-0 shadow-sm">
                  <div className="card-body p-4 p-md-5">

                    {/* POLÍTICA DE PRIVACIDAD */}
                    <section className="mt-4">
                      <h3 className="h5 mb-3">Política de privacidad</h3>

                      <p className="texto-regular" style={{ lineHeight: 1.7 }}>
                        Esta Política de privacidad describe cómo se recopila, utiliza y comparte su información personal cuando visita o
                        hace una compra en la app Zervicy (el "Sitio").
                      </p>

                      <h4 className="h6 fw-bold mt-4 mb-2">INFORMACIÓN PERSONAL QUE RECOPILAMOS</h4>
                      <p className="texto-regular" style={{ lineHeight: 1.7 }}>
                        Cuando visita el Sitio, recopilamos automáticamente cierta información sobre su dispositivo, incluida información
                        sobre su navegador web, dirección IP, zona horaria y algunas de las cookies que están instaladas en su dispositivo.
                        Además, a medida que navega por el Sitio, recopilamos información sobre las páginas web individuales o los productos
                        que usted ve, los sitios web o los términos de búsqueda que le remitieron al Sitio, y la información sobre cómo
                        interactúa con el Sitio. Nos referimos a esta información recopilada automáticamente como "Información del
                        dispositivo".
                      </p>

                      <p className="texto-regular mb-2" style={{ lineHeight: 1.7 }}>
                        Recopilamos información del dispositivo usando las siguientes tecnologías:
                      </p>
                      <ul className="mb-3" style={{ lineHeight: 1.7 }}>
                        <li>
                          Las "cookies" son archivos de datos que se colocan en su dispositivo o computadora y a menudo incluyen un
                          identificador único anónimo. Para obtener más información sobre las cookies y sobre cómo desactivar las cookies,
                          visite{" "}
                          <a href="http://www.allaboutcookies.org" target="_blank" rel="noreferrer">http://www.allaboutcookies.org</a>.
                        </li>
                        <li>
                          "Registrar archivos" rastrea las acciones que ocurren en el Sitio, y recopilar datos que incluyen su dirección IP,
                          tipo de navegador, proveedor de servicios de Internet, páginas de referencia / salida y sellos de fecha / hora.
                        </li>
                        <li>
                          Las "balizas web", las "etiquetas" y los "píxeles" son archivos electrónicos que se utilizan para registrar
                          información acerca de cómo navega por el Sitio.
                        </li>
                      </ul>

                      <p className="texto-regular" style={{ lineHeight: 1.7 }}>
                        Además, cuando realiza una compra o intenta realizar una compra a través del Sitio, recopilamos cierta información
                        de usted, incluidos su nombre, dirección de facturación, dirección de envío, información de pago, dirección de correo
                        electrónico y número de teléfono. Nos referimos a esta información como "Información de pedido".
                      </p>

                      <p className="texto-regular" style={{ lineHeight: 1.7 }}>
                        Cuando hablamos de "Información personal" en esta Política de privacidad, estamos hablando tanto de Información del
                        dispositivo como de Información del pedido.
                      </p>

                      <h4 className="h6 fw-bold mt-4 mb-2">¿CÓMO USAMOS TU INFORMACIÓN PERSONAL?</h4>
                      <p className="texto-regular" style={{ lineHeight: 1.7 }}>
                        Usamos la Información del pedido que recopilamos en general para cumplir con los pedidos realizados a través del
                        Sitio (incluido el procesamiento de su información de pago, la organización del envío y la entrega de facturas y / o
                        confirmaciones de pedido). Además, utilizamos esta información de pedido para:
                      </p>
                      <ul className="mb-3" style={{ lineHeight: 1.7 }}>
                        <li>Comunicarse contigo.</li>
                        <li>Examine nuestros pedidos de posibles riesgos o fraudes.</li>
                        <li>
                          Cuando esté en línea con las preferencias que ha compartido con nosotros, proporcione información o publicidad
                          relacionada con nuestros productos o servicios.
                        </li>
                      </ul>

                      <p className="texto-regular" style={{ lineHeight: 1.7 }}>
                        Usamos la información del dispositivo que recopilamos para ayudarnos a detectar posibles riesgos y fraudes (en
                        particular, su dirección IP) y, en general, para mejorar y optimizar nuestro sitio (por ejemplo, al generar análisis
                        sobre cómo nuestros clientes exploran e interactúan con el Sitio, y para evaluar el éxito de nuestras campañas de
                        marketing y publicidad).
                      </p>

                      <h4 className="h6 fw-bold mt-4 mb-2">COMPARTIR SU INFORMACIÓN PERSONAL</h4>
                      <p className="texto-regular" style={{ lineHeight: 1.7 }}>
                        Compartimos su información personal con terceros para ayudarnos a usar su información personal, como se describe
                        anteriormente. Por ejemplo, también utilizamos Google Analytics para ayudarnos a comprender cómo usan nuestros
                        clientes el Sitio; puede obtener más información sobre cómo Google usa su Información personal aquí:{" "}
                        <a
                          href="https://www.google.com/intl/es/policies/privacy/"
                          target="_blank"
                          rel="noreferrer"
                        >
                          https://www.google.com/intl/es/policies/privacy/
                        </a>
                        . También puede darse de baja de Google Analytics aquí:{" "}
                        <a
                          href="https://tools.google.com/dlpage/gaoptout"
                          target="_blank"
                          rel="noreferrer"
                        >
                          https://tools.google.com/dlpage/gaoptout
                        </a>
                        .
                      </p>

                      <p className="texto-regular" style={{ lineHeight: 1.7 }}>
                        Finalmente, también podemos compartir su información personal para cumplir con las leyes y regulaciones aplicables,
                        para responder a una citación, orden de registro u otra solicitud legal de información que recibimos, o para proteger
                        nuestros derechos de otra manera.
                      </p>

                      <h4 className="h6 fw-bold mt-4 mb-2">PUBLICIDAD CONDUCTUAL</h4>
                      <p className="texto-regular" style={{ lineHeight: 1.7 }}>
                        Como se describió anteriormente, utilizamos su Información personal para proporcionarle anuncios específicos o
                        comunicaciones de marketing que creemos que pueden ser de su interés. Para obtener más información sobre cómo funciona
                        la publicidad dirigida, puede visitar la página educativa de la Iniciativa publicitaria de la red ("NAI") en{" "}
                        <a
                          href="http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work"
                          target="_blank"
                          rel="noreferrer"
                        >
                          http://www.networkadvertising.org/understanding-online-advertising/how-does-it-work
                        </a>
                        .
                      </p>

                      <p className="texto-regular mb-2" style={{ lineHeight: 1.7 }}>
                        Puede optar por excluirse de la publicidad dirigida mediante los siguientes enlaces:
                      </p>
                      <ul className="mb-3" style={{ lineHeight: 1.7 }}>
                        <li>
                          Facebook:{" "}
                          <a href="https://www.facebook.com/settings/?tab=ads" target="_blank" rel="noreferrer">
                            https://www.facebook.com/settings/?tab=ads
                          </a>
                        </li>
                        <li>
                          Google:{" "}
                          <a href="https://www.google.com/settings/ads/anonymous" target="_blank" rel="noreferrer">
                            https://www.google.com/settings/ads/anonymous
                          </a>
                        </li>
                        <li>
                          Bing:{" "}
                          <a
                            href="https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads"
                            target="_blank"
                            rel="noreferrer"
                          >
                            https://advertise.bingads.microsoft.com/en-us/resources/policies/personalized-ads
                          </a>
                        </li>
                      </ul>

                      <p className="texto-regular" style={{ lineHeight: 1.7 }}>
                        Además, puede optar por excluirse de algunos de estos servicios visitando el portal de exclusión voluntaria de
                        Digital Advertising Alliance en:{" "}
                        <a href="http://optout.aboutads.info/" target="_blank" rel="noreferrer">http://optout.aboutads.info/</a>.
                      </p>

                      <h4 className="h6 fw-bold mt-4 mb-2">NO SEGUIR</h4>
                      <p className="texto-regular" style={{ lineHeight: 1.7 }}>
                        Tenga en cuenta que no alteramos las prácticas de recopilación y uso de datos de nuestro Sitio cuando vemos una señal
                        de No rastrear desde su navegador.
                      </p>

                      <h4 className="h6 fw-bold mt-4 mb-2">TUS DERECHOS</h4>
                      <p className="texto-regular" style={{ lineHeight: 1.7 }}>
                        Si usted es residente en Europa, tiene derecho a acceder a la información personal que tenemos sobre usted y a
                        solicitar que se corrija, actualice o elimine su información personal. Si desea ejercer este derecho, comuníquese con
                        nosotros a través de la información de contacto a continuación.
                      </p>

                      <p className="texto-regular" style={{ lineHeight: 1.7 }}>
                        Además, si usted es un residente europeo, notamos que estamos procesando su información para cumplir con los
                        contratos que podamos tener con usted (por ejemplo, si realiza un pedido a través del Sitio), o de lo contrario
                        perseguir nuestros intereses comerciales legítimos enumerados anteriormente. Además, tenga en cuenta que su
                        información será transferida fuera de Europa, incluyendo a Canadá y los Estados Unidos.
                      </p>

                      <h4 className="h6 fw-bold mt-4 mb-2">RETENCIÓN DE DATOS</h4>
                      <p className="texto-regular" style={{ lineHeight: 1.7 }}>
                        Cuando realiza un pedido a través del Sitio, mantendremos su Información de Pedido para nuestros registros a menos y
                        hasta que nos solicite que eliminemos esta información.
                      </p>

                      <h4 className="h6 fw-bold mt-4 mb-2">CAMBIOS</h4>
                      <p className="texto-regular" style={{ lineHeight: 1.7 }}>
                        Podemos actualizar esta política de privacidad de vez en cuando para reflejar, por ejemplo, cambios en nuestras
                        prácticas o por otros motivos operativos, legales o reglamentarios.
                      </p>

                      <h4 className="h6 fw-bold mt-4 mb-2">CONTÁCTENOS</h4>
                      <p className="texto-regular mb-0" style={{ lineHeight: 1.7 }}>
                        Para obtener más información acerca de nuestras prácticas de privacidad, si tiene alguna pregunta o desea realizar un
                        reclamo, comuníquese con nosotros por correo electrónico a <strong>info@zervicy.com</strong> o por correo
                        utilizando los detalles que se brindan a continuación:
                      </p>
                      <p className="texto-regular mb-0" style={{ lineHeight: 1.7 }}>
                        <strong>Zervicy</strong>
                        <br />
                        [Re: Oficial de Cumplimiento de Privacidad]
                      </p>
                    </section>

                  
                   
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
        </>
    )
}

export default Privacidad;